module.exports = __webpack_public_path__ + "img/sdt_1.0d9ef9b2.jpg";